/**
 * Created by Victor Rojo on 7/6/18.
 */
import { Injectable, Optional, OnDestroy }     from '@angular/core';
import { Router }                   from '@angular/router';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import { NotificationsService }   from 'angular2-notifications';
import {interval as observableInterval ,  Unsubscribable as AnonymousSubscription ,  Subject } from 'rxjs';

import {Notification} from "../model/notification";
import {Page} from "../model/page";
import {AuthService} from "../shared/auth/auth.service";

@Injectable()
export class NotificationService implements OnDestroy {

  private basePath = "api/v1/notification/";
  private interval: AnonymousSubscription;
  private unreadSource = new Subject<Object>();
  private newNotificationsSource = new Subject<Object>();
  private lastUnreadCount: any[];
  private lastNotificationTimestamp: number;
  unreadChange$ = this.unreadSource.asObservable();
  newNotificationChange$ = this.newNotificationsSource.asObservable();

  constructor(private http:HttpClient,
              private router: Router,
              private authService: AuthService,
              private notificationsService: NotificationsService) {

    this.reloadUnreadNotificationsCount();
    this.getNewNotifications();
    this.startPolling();
  }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  get(id: string):Promise<any> {
    let url = this.basePath + id;
    return this.http
      .get(url)
      .toPromise()
      .then( response => response as Notification )
      .catch(error => this.errorHandler(error));
  }

  getPage(page=0, size=20, sort="", filter=""){
    let url = this.basePath;
    let params = new HttpParams();
    params = params.append('page', page.toString())
      .append('size', size.toString())
      .append('sort', sort)
      .append('filter', filter);
    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response as Page )
      .catch(error => this.errorHandler(error));
  }

  ack(ids:string[]): Promise<any>{
    let url = this.basePath + "web/ack";
    return this.http.post(url,ids, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }

  unreadCount(idiPlace: string):Promise<any> {
    let url = this.basePath + "unread";
    let params = new HttpParams();
    if ( idiPlace ) {
      params = params.append('idiPlace', idiPlace);
    }

    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response )
      .catch(error => this.errorHandler(error));
  }

  private reloadUnreadNotificationsCount():void {
    this.unreadCount(null)
      .then( records => {
          this.lastUnreadCount = records;
          this.unreadSource.next(records);
      })
  }

  private getNewNotifications():void {
    if ( !this.lastNotificationTimestamp ){
      this.getPage(0, 1,"launchDate,desc", "")
        .then( records => {
          if (records.content[0]) {
            this.lastNotificationTimestamp = records.content[0].launchDate;
          }
        })
    } else {
      let filter = "launchDate:>:" + this.lastNotificationTimestamp +":T";
      this.getPage(0, 20,"launchDate,desc", filter)
        .then( records => {

          if (records.content[0]) {
            this.lastNotificationTimestamp = records.content[0].launchDate;
            records.content.forEach((record:any) => {
              let toast;
              let options = {
                pauseOnHover: true,
                icons: {
                  success: this.notificationsService.icons.info,
                  warn: this.notificationsService.icons.warn,
                  error: this.notificationsService.icons.error
                }
              };
              if ( record.idNotificationLevel == 1 ) {
                toast = this.notificationsService.success( record.iPlace.iPlaceName, record.name, options);
              } else if ( record.idNotificationLevel == 2) {
                toast = this.notificationsService.warn( record.iPlace.iPlaceName, record.name, options);
              } else if ( record.idNotificationLevel == 3 || record.idNotificationLevel == 4 ) {
                toast = this.notificationsService.error( record.iPlace.iPlaceName, record.name, options);
              }
              if ( toast ) {
                let cloudDashboard = this.authService.getCloudDahsboard();
                toast.click.subscribe((event:any) => {
                  if ( cloudDashboard ) {
                    this.router.navigate(['cloud/notifications']);
                  } else {
                    this.router.navigate(['notifications']);
                  }
                });
              }
            });
            this.newNotificationsSource.next(records.content);
          }
        })
    }
  }

  getLastUnreadCount(){
    return this.lastUnreadCount;
  }

  startPolling(){
    if ( !this.interval ) {
      this.interval = observableInterval(10000)
        .subscribe(() => {
          if ( this.authService.isLogged() ) {
            this.reloadUnreadNotificationsCount();
            this.getNewNotifications();
          }
        });
    }
  }

  stopPolling(){
    if ( this.interval ) {
      this.interval.unsubscribe();
      this.interval = null;
    }
  }

  resetLastNotificationTimestamp(){
    this.lastNotificationTimestamp = null;
  }

  public ngOnDestroy(): void {
    this.stopPolling();
  }
}
